import { render } from "./BedCleaningQueue.vue?vue&type=template&id=120ee6ea&scoped=true"
import script from "./BedCleaningQueue.vue?vue&type=script&lang=js"
export * from "./BedCleaningQueue.vue?vue&type=script&lang=js"

import "./BedCleaningQueue.vue?vue&type=style&index=0&id=120ee6ea&lang=css"
import "./BedCleaningQueue.vue?vue&type=style&index=1&id=120ee6ea&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120ee6ea"]])

export default __exports__